import {PropsWithChildren} from "react";
import {classNames} from "@variocube/cube-ui";
import * as React from "react";
import {boxShadow} from "./themes";
import {stylesheet} from "typestyle";

export function Panel({children, className}: PropsWithChildren<{  className?: string }>) {
    return (
        <div className={classNames(className, styles.panel)}>
            {children}
        </div>
    )
}

const styles = stylesheet({
    panel: {
        backgroundColor: "#fff",
        margin: "0.75em",
        boxShadow,
    },
})